import noop from 'lodash/noop';
import { getContext, Symbols } from 'choerodon-ui/shared';
const BoardContext = getContext(Symbols.BoardContext, {
    changeActiveKey: noop,
    queryFields: [],
    saveCustomized: noop,
    getConfig: noop,
    getProPrefixCls: noop,
});
export default BoardContext;
